import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    isDocumentTagLoading: false,
    isInventoryTagLoading: false,
    isLocationTagLoading: false,
    isEquipmentTagLoading: false,
    isTicketLoading: false,
    isFleetTagLoading: false,
    isJobTagLoading: false,
    isResourceTagLoading: false,
    isToolkitTagLoading: false,
    error: null,
    document_tags: null,
    inventory_tags: null,
    location_tags: null,
    equipment_tags: null,
    ticket_live: null,
    fleet_tags: null,
    job_tags: null,
    resource_tags: null,
    toolkit_tags: null
};

const slice = createSlice({
    name: 'live_position',
    initialState,
    reducers: {
        // START LOADING

        startDocumentTagLoading(state) {
            state.isDocumentTagLoading = true;
        },
        startInventoryTagLoading(state) {
            state.isInventoryTagLoading = true;
        },
        startLocationTagLoading(state) {
            state.isLocationTagLoading = true;
        },
        startEquipmentTagLoading(state) {
            state.isEquipmentTagLoading = true;
        },
        startTicketLoading(state) {
            state.isTicketLoading = true;
        },
        startFleetTagLoading(state) {
            state.isFleetTagLoading = true;
        },
        startJobTagLoading(state) {
            state.isJobTagLoading = true;
        },
        startResourceTagLoading(state) {
            state.isResourceTagLoading = true;
        },
        startToolkitTagLoading(state) {
            state.isToolkitTagLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isTagsLoading = false;
            state.isDocumentTagLoading = false;
            state.isInventoryTagLoading = false;
            state.isLocationTagLoading = false;
            state.isEquipmentTagLoading = false;
            state.isFleetTagLoading = false;
            state.isJobTagLoading = false;
            state.isResourceTagLoading = false;
            state.isToolkitTagLoading = false;
            state.error = action.payload;
        },
        // GET DOCUMENTTAGS
        setDocumentTags(state, action) {
            state.isDocumentTagLoading = false;
            state.document_tags = action.payload;
        },
        // GET INVENTORYTAGS
        setInventoryTags(state, action) {
            state.isInventoryTagLoading = false;
            state.inventory_tags = action.payload;
        },
        // GET LOCATIONTAGS
        setLocationTags(state, action) {
            state.isLocationTagLoading = false;
            state.location_tags = action.payload;
        },
        // GET EQUIPMENTTAGS
        setEquipmentTags(state, action) {
            state.isEquipmentTagLoading = false;
            state.equipment_tags = action.payload;
        },
        // GET TICKETS
        setTicket(state, action) {
            state.isTicketLoading = false;
            state.ticket_live = action.payload;
        },
        // GET FLEETTAGS
        setFleetTags(state, action) {
            state.isFleetTagLoading = false;
            state.fleet_tags = action.payload;
        },
        // GET JOBTAGS
        setJobTags(state, action) {
            state.isJobTagLoading = false;
            state.job_tags = action.payload;
        },
        // GET RESOURCETAGS
        setResourceTags(state, action) {
            state.isResourceTagLoading = false;
            state.resource_tags = action.payload;
        },
        // GET TOOLKITTAGS
        setToolkitTags(state, action) {
            state.isToolkitTagLoading = false;
            state.toolkit_tags = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startLoading,
    startDocumentTagLoading,
    startInventoryTagLoading,
    startLocationTagLoading,
    startEquipmentTagLoading,
    startTicketLoading,
    startFleetTagLoading,
    startJobTagLoading,
    startResourceTagLoading,
    startToolkitTagLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getDocumentTags() {
    return async () => {
        dispatch(slice.actions.startDocumentTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/document_tags?date_filter=week`);
            dispatch(slice.actions.setDocumentTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getInventoryTags() {
    return async () => {
        dispatch(slice.actions.startInventoryTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/inventory_tags?date_filter=week`);
            dispatch(slice.actions.setInventoryTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getLocationTags() {
    return async () => {
        dispatch(slice.actions.startLocationTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/location_tags?date_filter=week`);
            dispatch(slice.actions.setLocationTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getEquipmentTags() {
    return async () => {
        dispatch(slice.actions.startEquipmentTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/equipment_tags?date_filter=week`);
            dispatch(slice.actions.setEquipmentTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTicketPosition() {
    return async () => {
        dispatch(slice.actions.startTicketLoading());
        try {
            const response = await axios.get(`/admin/ticket/live_position?date_filter=week`);
            dispatch(slice.actions.setTicket(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFleetTags() {
    return async () => {
        dispatch(slice.actions.startFleetTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/fleet_tags?date_filter=week`);
            dispatch(slice.actions.setFleetTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getJobTags() {
    return async () => {
        dispatch(slice.actions.startJobTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/job_tags?date_filter=week`);
            dispatch(slice.actions.setJobTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getResourceTags() {
    return async () => {
        dispatch(slice.actions.startResourceTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/resource_tags?date_filter=week`);
            dispatch(slice.actions.setResourceTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getToolkitTags() {
    return async () => {
        dispatch(slice.actions.startToolkitTagLoading());
        try {
            const response = await axios.get(`/admin/tag/live_position/toolkit_tags?date_filter=week`);
            dispatch(slice.actions.setToolkitTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
